var $ = require('../internals/export');

var log = Math.log;
var LN2 = Math.LN2;

// `Math.log2` method
// https://tc39.es/ecma262/#sec-math.log2
$({ target: 'Math', stat: true }, {
  log2: function log2(x) {
    return log(x) / LN2;
  }
});



//////////////////
// WEBPACK FOOTER
// ./~/core-js/modules/es.math.log2.js
// module id = 321
// module chunks = 0